import React from 'react';
import ChatLayout from '../../components/chat/ChatLayout';
var ChatPage = function () { return React.createElement(ChatLayout, null,
    React.createElement("div", null,
        React.createElement("section", null,
            React.createElement("h2", null, "Ingen melding er valgt"),
            React.createElement("p", null, "Velg en melding fra menyen")))); };
export default ChatPage;
